import Tracker from "@openreplay/tracker";

const tracker = new Tracker({
  projectKey: "aipoZaakREZgFfudFKkJ",
  ingestPoint: "https://replays.carrotsolutions.co.kr/ingest",
  crossdomain: {
    parentDomain: "*",
    enabled: true,
  },
  network: {
    capturePayload: true,
  },
  captureIFrames: true,
  __DISABLE_SECURE_MODE: true,
});

export default tracker;
